import resize from "../resize";
import Swiper, {Navigation} from "swiper";
Swiper.use([Navigation]);

const initPopularSlider = () => {
   const slider = document.querySelector(".popular__slider");

   const BREAKPOINT = 767;
   let swiper = null;

   function init() {
      if (!swiper) {
         swiper = new Swiper(slider, {
            loop: true,
            spaceBetween: 20,
            breakpoints: {
               1870: {                 
                  slidesPerView: 5,
               },
               1321: {                 
                  slidesPerView: 4,
               },
               997: {                 
                  slidesPerView: 3,
               },
               0: {
                  slidesPerView: 2,
               },
            },
            navigation: {
               nextEl: ".popular .slider-navigation__button--next",
               prevEl: ".popular .slider-navigation__button--prev",
               disabledClass: "last",
            },
         });
      }
   }

   function destroy() {
     if (swiper) {
       swiper.destroy();
       swiper = null;
     }
   }

   const resizeSwiper = () => {
      window.innerWidth > BREAKPOINT
         ? init()
         : destroy();
   }

   slider && resizeSwiper();
   slider && resize(resizeSwiper);
};

export default initPopularSlider;
